import { render } from "./UnitRegistrationForm.vue?vue&type=template&id=3656a706"
import script from "./UnitRegistrationForm.vue?vue&type=script&lang=js"
export * from "./UnitRegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__